import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useBrandsettings } from "../hooks/useBrandSettings";
import { BrandSettings } from "../models/types";
import { ScreenSmallerThen } from "../utilities/UIHelper";
import { NavbarIcon } from "./navbar/Icon";

export const WizardFooter = () => {
  const { data: branding } = useBrandsettings({});
  const [brand, setBrand] = useState<BrandSettings | null>(null);
  const isSmallScreen = ScreenSmallerThen("1100px");
  const hasBrandingSettings = Boolean(
    brand?.logo && brand?.primary_color && brand?.primary_color !== ""
  );
  const theme = useTheme();

  useEffect(() => {
    if (branding && branding?.results?.length > 0) {
      setBrand(branding?.results[0]);
    }
  }, [branding]);

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      paddingRight={isSmallScreen ? "20px" : "80px"}
      paddingBottom={isSmallScreen ? "20px" : "25px"}
    >
      <Box
        padding="8px 12px"
        display="flex"
        alignItems="center"
        borderRadius="4px"
        bgcolor={
          hasBrandingSettings && brand?.primary_color && brand?.primary_color !== ""
            ? brand.primary_color
            : theme.palette.custom.grey[500]
        }
      >
        {!hasBrandingSettings && (
          <Typography variant="h4" color="#fff" display="flex" gap="8px" alignItems="center">
            Powered by{" "}
            <NavbarIcon
              variant="fairo-white"
              color="none"
              sx={{
                minWidth: "13px",
                width: "13px",
                height: "16px",
                minHeight: "16px",
              }}
            />
          </Typography>
        )}
        {brand?.logo && hasBrandingSettings && (
          <img
            src={brand?.logo}
            alt="logo"
            style={{
              maxHeight: "16px",
              height: "auto",
              width: "auto",
            }}
          />
        )}
      </Box>
    </Box>
  );
};
